import React from 'react';
import ReactDOM from 'react-dom/client';
import './static/styles/global.css';
import reportWebVitals from './reportWebVitals';
import {
  RouterProvider,
} from "react-router-dom";
import { router } from './router';
import { SnackbarProvider } from 'notistack'
import { SessionProvider } from './context/session'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.Fragment>
    <SnackbarProvider />
    <SessionProvider>
      <RouterProvider router={router} />
    </SessionProvider>
  </React.Fragment>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
